export default "__VITE_ASSET__BRrTMGow__"